import { createApp } from 'vue';
import FormWrapper from 'ewi-ui/components/3-organisms/FormWrapper/FormWrapper.vue';
import { CANCELLATION_SCHEMA } from 'ewi-ui-helpers/FormUtils/ValidationSchemas/cancellation-schema.ts';
import { makeServer } from './mockServer.js';
import { createPinia } from 'pinia';

if (import.meta.env.DEV === true) {
  console.log('Starting MirageJS mock server.');
  makeServer();
}

const pinia = createPinia();

let cancellationMountElement = document.getElementById('vue-cancellation');
if (cancellationMountElement) {
  let dataset = cancellationMountElement.dataset;
  const app = createApp(FormWrapper, {
    schema: {
      ...CANCELLATION_SCHEMA,
      submitAction: {
        ...CANCELLATION_SCHEMA.submitAction,
        redirectUrl: dataset.redirect,
      },
      footer: {
        ...CANCELLATION_SCHEMA.footer,
        placeholderReplacement: dataset.loyaltyLink,
      },
    },
  });
  app.config.globalProperties.$window = window;

  window.addEventListener('pageshow', function () {
    app.use(pinia).mount(cancellationMountElement);
  });
}
